import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-company-create-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './company-create-password.component.html',
  styleUrl: './company-create-password.component.scss'
})
export class CompanyCreatePasswordComponent {

  recoverPasswordForm: FormGroup
  errorMessage: string = "";
  token_mail: string = "";
  type: string = ""
  isLoading: boolean = false;
  confirmPasswordMessage: string = "";
  changed: boolean = false;


  constructor(private formb: FormBuilder, private http: HttpClient, private route: ActivatedRoute, private router: Router, private translate: TranslateService) {
    this.recoverPasswordForm = formb.group({
      password: ["", Validators.required],
      confirmPassword: ["", Validators.required],
    });
    this.route.queryParams.subscribe(params => {
      this.token_mail = params['token_mail'];
      this.type = params['user_type'];
    });

    this.confirmPasswordMessage = "";
    this.errorMessage = "";
  }

  onSubmit() {
    if (this.recoverPasswordForm.get('password')?.value !== this.recoverPasswordForm.get('confirmPassword')?.value) {
      this.errorMessage = this.translate.instant('companyCreatePassword.errors.passwordsNotMatch');
      this.confirmPasswordMessage = "";
      return;
    }
    else if (this.recoverPasswordForm.valid){
      this.errorMessage = "";
      this.confirmPasswordMessage = "";
      this.isLoading = true;
      const body = {
        token_mail: this.token_mail,
        password: this.recoverPasswordForm.get('password')?.value,
        user_type: this.type
      }

      this.http.post(`${environment.url}/api/v1/password/reset`, body).subscribe({
        next: (response: any) => {
            this.confirmPasswordMessage = response.message;
            this.changed = true;
          this.isLoading = false;
        },
        error: (error: any) => {
          this.errorMessage = error.error.error;
          this.isLoading = false;
        }
      });
    }
    else{
      this.errorMessage = this.translate.instant('companyCreatePassword.errors.completeFields');
      this.confirmPasswordMessage = "";
      return;
    }
  }

  navigateToLogin() {
    this.router.navigate(['/company/login']);
  }
}
